/* eslint-disable max-len */
export default {
  // baseUrl: 'http://localhost:6400/api/',
  baseUrl: "https://loi-api.autonet.co.in/api/",
  googleMapsApiKey: "AIzaSyD4WSUmy8f1tDcbik6CrjF4QSwLi5Cx2vw",
};
